export default __webpack_public_path__ + "static/ThinkstockPhotos-160120040_article-8b673e6401248c75353af539fed7f428.jpg";